/** @file Maps arbitrary source names (PSD layers, file names) onto the ASCII name rule, deduplicating. */
import { names } from './names';

const strip = (raw: string): string =>
  raw
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^A-Za-z0-9_-]+/g, '')
    .replace(/^[-_]+/, '');

/** Returns an ASCII name ≤64 chars unique against `taken` (base truncated before a `-<n>` suffix); `index` seeds `layer-<n>`. */
export function slugifyName(
  raw: string,
  taken: ReadonlySet<string>,
  index: number,
): { name: string; renamed: boolean } {
  const cleaned = strip(raw);
  // A name that had letters but lost them all (e.g. Thai) is not meaningful; fall back to layer-<n>.
  const lostLetters = /\p{L}/u.test(raw) && !/[A-Za-z]/.test(cleaned);
  const raw64 = cleaned.slice(0, names.MAX);
  const base = names.RE.test(raw64) && !lostLetters ? raw64 : `layer-${index}${cleaned ? `-${cleaned}` : ''}`.slice(0, names.MAX);
  let name = base;
  let n = 2;
  while (taken.has(name)) {
    const suffix = `-${n++}`;
    name = `${base.slice(0, names.MAX - suffix.length)}${suffix}`;
  }
  return { name, renamed: name !== raw };
}
